import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EFPicture from '@elem/ui/ef-picture';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import { Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

const UserTrust: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('UserTrust');

    const tableData = [
        {
            title: t('compare_title_1'),
            title_image:
                locale === 'us'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1760182337145/%E5%8F%B3%E4%BE%A7%E4%BF%AF%E8%A7%86%201.png'
                    : 'https://websiteoss.ecoflow.com/upload/image/1749780401587/product2.png',
            tbody: [
                t('compare_desc_1_1'),
                t('compare_desc_1_2'),
                t('compare_desc_1_3'),
                t('compare_desc_1_4'),
                t('compare_desc_1_5'),
                t('compare_desc_1_6'),
                t('compare_desc_1_7'),
                t('compare_desc_1_8'),
                t('compare_desc_1_9'),
            ],
        },
        {
            title: t('compare_title_2'),
            title_image: 'https://websiteoss.ecoflow.com/upload/image/1749780401386/product1.png',
            tbody: [
                t('compare_desc_2_1'),
                t('compare_desc_2_2'),
                t('compare_desc_2_3'),
                t('compare_desc_2_4'),
                t('compare_desc_2_5'),
                t('compare_desc_2_6'),
                t('compare_desc_2_7'),
                t('compare_desc_2_8'),
                t('compare_desc_2_9'),
            ],
        },
        {
            title: t('compare_title_3'),
            title_image: 'https://websiteoss.ecoflow.com/upload/image/1749780401809/product3.png',
            tbody: [
                t('compare_desc_3_1'),
                t('compare_desc_3_2'),
                t('compare_desc_3_3'),
                t('compare_desc_3_4'),
                t('compare_desc_3_5'),
                t('compare_desc_3_6'),
                t('compare_desc_3_7'),
                t('compare_desc_3_8'),
                t('compare_desc_3_9'),
            ],
        },
    ];

    const pcTableData = [tableData[1], tableData[0], tableData[2]];

    return (
        <div className={`${styles.UserTrust} GtmModuleData-section`} data-section-id={'powerPreparedness-UserTrust'} data-section-title={t('title')}>
            <div className="page-space space-1"></div>
            <EcoSectionCommon title={t('title')} desc={t('desc')} />
            <div className="table_wrapper page-layout">
                <div className="pc-wrapper">
                    <table className="table">
                        <tbody className="tbody">
                            <tr className="tr thead-tr">
                                {pcTableData.map((item, index) => (
                                    <td className={'td '} key={index}>
                                        <EFPicture className="title_image" src={item.title_image} />
                                        <p className="title">{item.title}</p>
                                    </td>
                                ))}
                            </tr>
                            {Array(9)
                                .fill(0)
                                .map((_, index) => {
                                    return (
                                        <tr className="tr" key={index}>
                                            {pcTableData.map((item, _index) => (
                                                <td className="td" key={_index}>
                                                    <p className="text">{item.tbody[index]}</p>
                                                </td>
                                            ))}
                                        </tr>
                                    );
                                })}
                        </tbody>
                    </table>
                    <div className="center-wrapper">
                        <div className="center-header">
                            <EFPicture className="title_image" src={tableData[0].title_image} />
                            <p className="title">{tableData[0].title}</p>
                        </div>
                        <div className="center-body">
                            {tableData[0].tbody.map((item, index) => (
                                <div className="center-body-item" key={index}>
                                    {item}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <Swiper
                    spaceBetween={0}
                    slidesPerView={'auto'}
                    modules={[Scrollbar]}
                    scrollbar={{
                        hide: false,
                        draggable: true,
                        dragSize: 25,
                        snapOnRelease: true,
                    }}
                >
                    <SwiperSlide className="table-item active-item">
                        <div className="table-header">
                            <EFPicture className="title_image title_image_active" src={tableData[0].title_image} />
                            <p className="title title_active">{tableData[0].title}</p>
                        </div>
                        <div className="table-body">
                            {tableData[0].tbody.map((item, index) => (
                                <p className="table-text" key={index}>
                                    {item}
                                </p>
                            ))}
                        </div>
                    </SwiperSlide>

                    {[tableData[1], tableData[2]].map((item, index) => (
                        <SwiperSlide className="table-item" key={index}>
                            <div className="table-header">
                                <EFPicture className="title_image" src={item.title_image} />
                                <p className={'title ' + 'title_' + (index + 1)}>{item.title}</p>
                            </div>
                            <div className="table-body">
                                {item.tbody.map((item, index) => (
                                    <p className="table-text" key={index}>
                                        {item}
                                    </p>
                                ))}
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>

            <div className="page-space"></div>
        </div>
    );
};

export default UserTrust;
